<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center bg-white z-50">
    <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- isLoading est false on peut passer sur l'ecran classique -->
<div *ngIf="!isLoading"
    class="relative flex flex-col min-h-screen font-poppins bg-[url('{{ posBanner }}')] bg-cover bg-center text-gray-900">
    <!-- Overlay gris transparent -->
    <div class="absolute inset-0 bg-black/20 pointer-events-none z-0"></div>

    <!-- Contenu -->
    <div class="relative z-10 h-screen flex flex-col mx-auto sm:w-[600px]">

        <!-- section top -->
        <div class="flex-1">

            <!-- toolbar -->
            <div class="flex flex-row justify-between p-2.5">

                <div class="flex flex-row justify-end gap-2.5">

                    <!-- Bouton Home en haut à droite
                    <button routerLink="/home"
                        class="bg-white shadow rounded-full w-10 h-10 flex items-center justify-center">
                        <mat-icon class="text-gray-500 hover:text-primary">home</mat-icon>
                    </button> -->

                </div>

                <!-- Logo -->
                <div class="flex justify-center mx-auto max-w-2xl" *ngIf="pointOfSale && pointOfSale.img">
                    <img src="{{ pointOfSale.img }}" alt="Logo"
                        class="w-24 h-24 rounded-full mb-2 object-cover">
                </div>

            </div>

            <!-- entête -->
            <div *ngIf="pointOfSale" class="bg-white mx-4 p-4 shadow rounded-2xl max-w-2xl flex flex-col items-center">

                <!-- Table concernée (optionnel) -->
                <div *ngIf="routeParams['locValue'] > 0">
                  <div class="mb-4">
                    <h1 class="font-bold text-center mb-2 text-2xl text-primary">
                      TABLE {{ routeParams['locValue'] }}
                    </h1>
                  </div>
                </div>

                <h2 class="font-bold text-center mb-2 text-xl text-primary">
                    {{ pointOfSale.denomination }}
                </h2>
                <p class="text-sm text-center text-gray-600 mb-6">
                    {{ pointOfSale.address }}<br>
                    {{ pointOfSale.postal }} {{ pointOfSale.city }}<br>
                    <span *ngIf="pointOfSale.phone">Tel : {{ pointOfSale.phone }}</span>
                </p>
            </div>

            <!-- Boutons modals -->
            <div *ngIf="buttonsReady" class="flex flex-col justify-center gap-4 mt-6">

                <!-- Bouton Commander -->
                <button *ngIf="showCommander && shortUrlOrderCode" (click)="navigate(shortUrlOrderCode)"
                    class="bg-white mx-4 p-4 shadow rounded-2xl max-w-2xl flex flex-col items-center font-bold text-center mb-2 text-lg text-primary">
                    Commander
                </button>

                <!-- Bouton Menu -->
                <button *ngIf="!showCommander && shortUrlMenuCode" (click)="openShortUrl(shortUrlMenuCode)"
                    class="bg-white mx-4 p-4 shadow rounded-2xl max-w-2xl flex flex-col items-center font-bold text-center mb-2 text-lg text-primary">
                    Menu
                </button>

                <!-- Bouton Payer -->
                <button *ngIf="showPayer" (click)="navigate(paymentRoute)"
                    class="bg-white mx-4 p-4 shadow rounded-2xl max-w-2xl flex flex-col items-center font-bold text-center mb-2 text-lg text-primary">
                    Payer
                </button>

            </div>

        </div>
    </div>
</div>
